/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { APP_CONFIG } from "../../config/config";
import LoginImage from "../../assets/images/LoginImage.png";
import CopyrightImage from "../../assets/images/copyright.svg";
import LogoImage from "../../assets/images/Logo.png";
import { useEffect } from "react";
import { ENDPOINT } from "../../services/api-endpoint";
import { useNavigate } from "react-router-dom";
import { getVerify } from "../../services/services";
import "./mes-login.scss";

enum AppIds {
  CONTROL_APP = "czLaDXzMuw"
}

const MesLogin = () => {
  const tOneUrl = APP_CONFIG.tOneUrl + '/auth/';
  const navigate = useNavigate();

  async function onLoad() {
    try {
      const list = await getVerify(ENDPOINT.LOGIN_CHECK);
      if (list) {
        localStorage.setItem("user", JSON.stringify(list));
        navigate("/mes-dashboard");
      }
    } catch (e) {
      console.log(`Error in getOperation: ${e}`);
    }
  }

  useEffect(() => {
    let auth = (new URLSearchParams(window.location.search)).get('auth')
    if (auth) {
      localStorage.setItem('auth', auth);
      onLoad();
    }
  }, []);

  function getBaseUrl() {
    const url = new URL(window.location.href);
    const baseUrl = `${url.protocol}//${url.hostname}/`;
    return encodeURIComponent(baseUrl);
  }

  function redirectToLogin(){
    const loginUrl = `${tOneUrl}login?app_id=${AppIds.CONTROL_APP}&redirect_uri=${getBaseUrl()}`;
    window.location.href = loginUrl;
  }

  return (
    <div className="container-fluid">
      <div className="row text-center">
        <div className="col-6 pl-0">
          <img className="w-100 image-container" src={LoginImage} />
          <div className="bottom-license text-center">
            <img className="w-17-px" src={CopyrightImage} />
            <p className="d-inline m-0">&nbsp;&nbsp;&nbsp;&nbsp;2021 Truventor AI &
              Robotics&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;All Rights Reserved.</p>
          </div>
        </div>
        <div className="col-6 back-image">
          <div className="card login_card">
            <div className="card-content">
              <div className="card-title">
                <img className="h-auto" alt="Truventor logo"
                  src={LogoImage} />
              </div>
              <p>Login into your Truventor Control Account</p>
              <a onClick={redirectToLogin} className="btn btn-orange mt-3 p-3 w-100">
                Log In With Truventor One
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default MesLogin;
